import "./our-people.scss";
import Parallax from "../../components/parallax/parallax";
import { useEffect, useState, useCallback } from "react";
import { getImageUrls } from "../../utils/getImageUrls";
import LoadingOverlay from "../../components/loading/LoadingOverlay";

export default function OurPeople() {
  //bridesmaids imageUrls
  const [bridesmaidsImgUrls, setBridesmaidsImgUrls] = useState([]);
  //groomsmen imageUrls
  const [groomsmenImgUrls, setGroomsmenImgUrls] = useState([]);

  //track flipped images
  const [flipped, setFlipped] = useState({});

  const parents_img = [
    {
      src: `${process.env.PUBLIC_URL}/images/parents/MomDad_Ella.webp`,
      alt: "Ella's Parents",
      names: "JUN & NIQUE DIAZ",
    },
    {
      src: `${process.env.PUBLIC_URL}/images/parents/Mom_CJ.webp`,
      alt: "CJ's Mom",
      names: "LUCILLE RALLOS",
    },
    {
      src: `${process.env.PUBLIC_URL}/images/parents/Dad_CJ.webp`,
      alt: "CJ's Dad",
      names: "DANIE RALLOS",
    },
  ];

  const bridesmaidsLabels = [
    {
      fullName: "GABRIELA RIBO",
      title: "MATRON OF HONOR",
    },
    {
      fullName: "MEG TUANO",
      title: "MAID OF HONOR",
    },
    {
      fullName: "ZYMA DEQUIT",
    },
    {
      fullName: "ABIGAIL DIXON",
    },
    {
      fullName: "RIKKA DOLORES",
    },
    {
      fullName: "MIA PAJATIN",
    },
    {
      fullName: "KRISTINE SABIDO",
    },
  ];

  const groomsmenLabels = [
    {
      fullName: "CHRISTIAN NAYVE",
      title: "BEST MAN",
    },
    {
      fullName: "EJ ALFON",
    },
    {
      fullName: "JOVER BRINAS",
    },
    {
      fullName: "ISAIAH CRUZ",
    },
    {
      fullName: "XAVIER PASICOLAN",
    },
    {
      fullName: "JOVIN RIBO",
    },
    {
      fullName: "RENZ YABES",
    },
  ];

  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    getImageUrls("bridesmaids").then((urls) => {
      setBridesmaidsImgUrls(urls);

      const initial = {};
      for (let i = 0; i < urls.length; i += 2) {
        initial[`bridesmaids-${i}`] = false;
      }
      setFlipped((prev) => ({ ...prev, ...initial }));
    });
    getImageUrls("groomsmen").then((urls) => {
      setGroomsmenImgUrls(urls);

      const initial = {};
      for (let i = 0; i < urls.length; i += 2) {
        initial[`groomsmen-${i}`] = false;
      }
      setFlipped((prev) => ({ ...prev, ...initial }));
    });
    // setImagesLoaded(true);
  }, []);

  useEffect(() => {
    if (groomsmenImgUrls.length > 10 && bridesmaidsImgUrls.length > 10) {
      const timeoutId = setTimeout(() => {
        setImagesLoaded(true);
      }, 1500);
      return () => clearTimeout(timeoutId);
    }
  });

  // Auto-toggle every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setFlipped((prev) => {
        const next = {};
        for (const key in prev) {
          next[key] = !prev[key];
        }
        return next;
      });
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const toggleFlip = useCallback((key) => {
    setFlipped((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const renderImages = useCallback(
    (array, labels, group) => {
      return array.map((url, index) => {
        if (index % 2 !== 0) return null;

        const key = `${group}-${index}`;
        const labelData = labels[Math.floor(index / 2)] || {};
        const frontUrl = url;
        const backUrl = array[index + 1];

        return (
          <div
            key={key}
            className="people-container display-flex flex-column justify-center text-center align-center"
          >
            <div className="people-box">
              <div
                className="image-wrapper"
                onClick={() => toggleFlip(key)}
                onMouseEnter={() => toggleFlip(key)}
              >
                <img
                  src={backUrl}
                  alt={labelData.fullName || ""}
                  className="people-img back"
                  loading="lazy"
                />
                <img
                  src={frontUrl}
                  alt={labelData.fullName || ""}
                  className="people-img front"
                  style={{ opacity: flipped[key] ? 0 : 1 }}
                  loading="lazy"
                />
              </div>

              {labelData.title && (
                <p className="people-title">{labelData.title}</p>
              )}
              {labelData.fullName && (
                <p className="people-label">{labelData.fullName}</p>
              )}
            </div>
          </div>
        );
      });
    },
    [flipped, toggleFlip]
  );

  return (
    <>
      <LoadingOverlay isLoading={!imagesLoaded} />
      <div className={`padding-bottom-60 ${imagesLoaded ? "fade-in" : ""}`}>
        <section className="our-people-banner banner">
          <Parallax className="our-people-image" speed={-0.2} />
          <div className="our-people-bg width-100 overflow-hiddden position-absolute"></div>
          <h1 className="cormorant-400 font-size-8 letter-spacing-6 position-relative margin-0 text-light">
            OUR PEOPLE
          </h1>
        </section>
        <section className="parents padding-top-22">
          <h1 className="cormorant-400 font-size-8 letter-spacing-4 position-relative margin-top-0 margin-bottom-1 text-medium text-center">
            THE PARENTS
          </h1>
          <p className="text-center">
            We’re beyond grateful for everything our parents have done for us.
            Their love, support, and countless sacrifices have laid the
            foundation for the lives we’re living today. Everything we are — and
            everything we hope to become — has been shaped by their example, and
            we couldn’t be more thankful. <br />
            <br /> — Chris & Ella <br />
            <br />
            To my mother, watching from heaven — I carry your love with me every
            day, and I hope I’ve made you proud. <br />
            <br />— Chris
          </p>
          <div className="parents-photos">
            {parents_img.map(({ index, src, alt, names }) => (
              <div className="parent-photo-container">
                <img key={index} src={src} alt={alt} loading="lazy" />
                <p>{names}</p>
              </div>
            ))}
          </div>
        </section>
        <section className="bridesmaids padding-top-22 text-center">
          <h1 className="cormorant-500 font-size-8 letter-spacing-4 position-relative margin-0 text-medium">
            THE BRIDESMAIDS
          </h1>
          <div className="bridesmaids-photos">
            {renderImages(bridesmaidsImgUrls, bridesmaidsLabels, "bridesmaids")}
          </div>
        </section>
        <section className="groomsmen padding-top-22 text-center">
          <h1 className="cormorant-500 font-size-8 letter-spacing-4 position-relative margin-0 text-medium">
            THE GROOMSMEN
          </h1>
          <div className="groomsmen-photos">
            {renderImages(groomsmenImgUrls, groomsmenLabels, "groomsmen")}
          </div>
        </section>
      </div>
    </>
  );
}
